<template>
  <section class="announcement-section py-5 bg-white">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div v-if="latest" class="card announcement-main shadow-lg">
            <!-- Imaginea anunÈ›ului -->
            <img :src="latest.image" class="card-img-top" v-if="latest.image" />

            <div class="card-body text-center">
              <h2 class="announcement-title text-primary">{{ latest.title }}</h2>
                <p class="announcement-text" v-html="formatDescription(latest.description)"></p>
              <small class="text-muted d-block">{{ latest.created_at }}</small>
            </div>
          </div>

          <div v-else class="text-center">
            <p class="text-muted">{{ $t("announcements.noAnnouncements") }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "SiteAnnouncements",
  data() {
    return {
      latest: null,
    };
  },
  async mounted() {
    await this.fetchAnnouncements();
  },
  
  methods: {
    async fetchAnnouncements() {
      try {
        const response = await axios.get("https://api.feribot-eurobac.ro/client/api/announcements/", {
          params: { lang: this.$i18n.locale },
        });
        this.latest = response.data.latest;
      } catch (error) {
        console.error("Eroare la preluarea anunÈ›ului:", error);
      }
    },  formatDescription(text) {
    if (!text) return '';
    return text.replace(/\n/g, '<br>');
  },
  },  watch: {
    "$i18n.locale"() {
      this.fetchAnnouncements(); // 🔹 Actualizăm anunțurile când se schimbă limba
    },
  },
};
</script>

<style scoped>
/* ðŸ”¹ SecÈ›iunea principalÄƒ */
.announcement-section {
  background: #f8f9fa;
  margin-top: -140px;
  margin-bottom: 70px;
}

/* ðŸ”¹ Stilizare card anunÈ› */
.announcement-main {
  border-radius: 15px;
  overflow: hidden;
  background: white;
  padding: 25px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
}

.announcement-main:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

/* ðŸ”¹ Imaginea anunÈ›ului */
.card-img-top {
  height: 250px;
  object-fit: cover;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

/* ðŸ”¹ Titlu È™i text */
.announcement-title {
  font-size: 1.8rem;
  font-weight: bold;
  color: #001f3f;
  margin-top: 15px;
}

.announcement-text {
  font-size: 1.2rem;
  color: #6c757d;
  max-width: 700px;
  margin: 10px auto;
}

/* ðŸ”¹ Mesaj cÃ¢nd nu existÄƒ anunÈ›uri */
.text-muted {
  font-size: 1.2rem;
}
</style>
